import React from "react";
import { joinClassnames, mapMultiClassnames } from "utils/map-modifier";
import "./index.scss";

type Variant = "success" | "error";
interface FilterProductProps {
  children?: React.ReactNode;
}

interface ItemProps {
  children: React.ReactNode;
  modifiers?: Modifiers;
  useDivTag?: boolean;
  useLimitWidthCode?: boolean;
  centerContent?: boolean;
  alignLeft?: boolean;
  noSpacingRight?: boolean;
  variant?: Variant;
}

interface TitleProps {
  children: React.ReactNode;
}

interface Component extends React.FC<FilterProductProps> {
  Item: React.FC<ItemProps>;
  Title: React.FC<TitleProps>;
}

const FilterProduct: Component = ({ children }: FilterProductProps) => (
  <ul className="m-filter-product">{children}</ul>
);

FilterProduct.Item = ({
  children,
  modifiers,
  useDivTag,
  useLimitWidthCode,
  centerContent,
  alignLeft,
  noSpacingRight,
  variant,
}: ItemProps) =>
  useDivTag ? (
    <div
      className={joinClassnames(
        mapMultiClassnames("m-filter-product-item", modifiers),
        centerContent && "use-center-content",
        alignLeft && "align-left",
        useLimitWidthCode && "use-limit-width-code",
        noSpacingRight && "no-spacing-right",
        variant && variant,
      )}
    >
      {children}
    </div>
  ) : (
    <li className={mapMultiClassnames("m-filter-product-item", modifiers)}>
      {children}
    </li>
  );

FilterProduct.Title = ({ children }: TitleProps) => <label>{children}</label>;

export default FilterProduct;
